(function () {
  const U = window.UIX;
  const Core = window.RB.Core;
  const APP = window.APP;
  const el = U.el;
  const esc = U.esc;

  const W = 1440;
  const H = 900;

  const CARD = {
    oppHand: { w: 96, h: 134 },
    myHand: { w: 168, h: 235 },
    oppIdent: { w: 74, h: 103 },
    myIdent: { w: 82, h: 114 },
  };

  function slot(cls, dx, y, w, h, rot, z, from) {
    const s = el("div", "arslot" + (cls ? " " + cls : ""));
    const bottom = from === "bottom";
    s.style.left = "calc(50% + " + dx.toFixed(2) + "px)";
    s.style[bottom ? "bottom" : "top"] = y.toFixed(2) + "px";
    if (w) s.style.width = w + "px";
    if (h) s.style.height = h + "px";
    s.style.transform = "translate(-50%," + (bottom ? "50%" : "-50%") + ")" +
      (rot ? " rotate(" + rot + "deg)" : "");
    if (z) s.style.zIndex = String(z);
    return s;
  }

  function fan(n, o) {
    const out = [];
    const mid = (n - 1) / 2;
    const dmax = Math.max(mid, 0.0001);
    const step = n > 1 ? Math.min(o.step, o.width / (n - 1)) : 0;
    const rotStep = n > 1 ? Math.min(o.rot, o.arc / (n - 1)) : 0;
    const flip = o.flip ? -1 : 1;
    for (let i = 0; i < n; i++) {
      const d = i - mid;
      out.push({
        x: o.cx + d * step,
        y: o.cy + flip * o.drop * (d * d) / (dmax * dmax),
        rot: flip * d * rotStep,
      });
    }
    return out;
  }

  function handCards(state, p) {
    const pl = state.players[p];
    const held = RB.Anim && RB.Anim.heldItem ? RB.Anim.heldItem(state) : null;
    const shown = pl.hand.slice();
    if (held && held.controller === p) {
      const at = held.handIndex >= 0 ? Math.min(held.handIndex, shown.length) : shown.length;
      shown.splice(at, 0, held.iid);
    }
    return shown;
  }

  const HAND_CFG = {
    mine: { cx: 0, cy: 78, width: 700, step: 66, arc: 30, rot: 5, drop: -26, flip: false, from: "bottom" },
    opp: { cx: 0, cy: 74, width: 520, step: 58, arc: 26, rot: 5.2, drop: 16, flip: true, from: "top" },
  };

  function renderHand(state, p, mine) {
    const pl = state.players[p];
    const wrap = el("div", "arhand handfan " + (mine ? "mine" : "opp"));
    wrap.setAttribute("data-anchor", "hand-" + p);
    const shown = handCards(state, p);
    const cfg = mine ? HAND_CFG.mine : HAND_CFG.opp;
    const size = mine ? CARD.myHand : CARD.oppHand;
    const n = mine ? shown.length : Math.min(shown.length, 12);
    const lay = fan(n, cfg);
    for (let i = 0; i < n; i++) {
      const s = slot("arhcard", lay[i].x, lay[i].y, size.w, size.h, lay[i].rot, 40 + i, cfg.from);
      if (mine) {
        s.appendChild(U.renderHandCard(state, shown[i]));
      } else {
        const back = el("div", "cardback hback", U.backSvg(18));
        back.setAttribute("data-fxkey", "@hb-" + p + "-" + i);
        if (RB.Anim && RB.Anim.hidden["@hb-" + p + "-" + i]) back.classList.add("prearrive");
        s.appendChild(back);
      }
      wrap.appendChild(s);
    }
    if (!n) {
      const empty = slot("arhempty", cfg.cx, cfg.cy, 150, 34, 0, 40, cfg.from);
      empty.appendChild(el("span", "zlabel", "Hand is empty"));
      wrap.appendChild(empty);
    }
    if (!mine) {
      const count = shown.length + " card" + (shown.length === 1 ? "" : "s");
      wrap.title = U.seatName(state, p) + "'s hand — " + count + ". " + (APP.net ? "Hidden from you."
        : APP.ai[p] ? "The AI's hand stays hidden." : "Click to view from " + U.seatName(state, p) + "'s side.");
      if (!APP.net && !APP.ai[p]) {
        wrap.classList.add("flippable");
        wrap.onclick = function (ev) { ev.stopPropagation(); APP.viewAs = p; U.render(); };
      }
    }
    return wrap;
  }

  function renderPiles(state, p, mine) {
    const row = el("div", "arpiles");
    const order = mine
      ? [["banish", "Banish"], ["trash", "Trash"], ["deck", "Deck"]]
      : [["deck", "Deck"], ["trash", "Trash"], ["banish", "Banish"]];
    for (const [key, label] of order) {
      if (key === "deck") row.appendChild(U.renderDeckSlot(state, p));
      else row.appendChild(U.renderPileSlot(state, p, key, label, key + "-" + p));
    }
    return row;
  }

  function renderIdentity(state, p, mine) {
    const pl = state.players[p];
    const row = el("div", "arident");
    const legend = U.renderLegendSlot(state, p);
    const xp = el("span", "chip arxp", "XP " + pl.xp);
    xp.title = U.seatName(state, p) + " has " + pl.xp + " XP";
    legend.appendChild(xp);
    const champ = U.renderChampSlot(state, p, mine);
    if (mine) {
      row.appendChild(legend);
      row.appendChild(champ);
    } else {
      row.appendChild(champ);
      row.appendChild(legend);
    }
    return row;
  }

  function renderCards(state, p, mine) {
    const pl = state.players[p];
    const box = el("div", "arcorner arcards " + (mine ? "br" : "tl") + " " + U.pcls(p));
    box.setAttribute("data-anchor", "side-" + p);
    box.title = U.seatName(state, p) + (APP.ai[p] ? " (AI)" : "") + " — " + pl.points + " / " +
      Core.victoryScore(state) + " points · XP " + pl.xp;
    const ident = renderIdentity(state, p, mine);
    const piles = renderPiles(state, p, mine);
    if (mine) {
      const btn = U.arenaTurnButton(state);
      if (btn) box.appendChild(btn);
      box.appendChild(ident);
      box.appendChild(piles);
    } else {
      box.appendChild(piles);
      box.appendChild(ident);
    }
    return box;
  }

  const RUNE_SLOTS = 12;

  function runeShelf(state, p) {
    const runes = U.baseRunes(state, p);
    const shelf = el("div", "arrunes");
    const grid = el("div", "arrunegrid");
    const slots = Math.max(RUNE_SLOTS, runes.length + state.players[p].runeDeck.length);
    for (const iid of runes) grid.appendChild(U.renderRune(state, iid));
    for (let i = runes.length; i < slots; i++) grid.appendChild(el("div", "runehole"));
    shelf.appendChild(U.runeDeckPile(state, p));
    shelf.appendChild(el("div", "runesplit"));
    shelf.appendChild(grid);
    return shelf;
  }

  function renderPool(state, p) {
    const pl = state.players[p];
    const legend = pl.legendIid ? Core.card(state, pl.legendIid) : null;
    const doms = (legend && legend.domains) || [];
    const box = el("div", "arpool");
    box.setAttribute("style", "--d1: var(--" + (doms[0] || "order") + "); --d2: var(--" + (doms[1] || doms[0] || "order") + ");");
    const pool = U.poolSection(state, p) || el("div", "poolgroup empty", "<span class='zlabel'>POOL</span>");
    pool.setAttribute("data-anchor", "pool-" + p);
    box.appendChild(pool);
    box.appendChild(el("div", "runesplit"));
    box.appendChild(runeShelf(state, p));
    return box;
  }

  function renderRunes(state, p, mine) {
    const box = el("div", "arcorner arside " + (mine ? "bl" : "tr") + " " + U.pcls(p));
    box.appendChild(renderPool(state, p));
    return box;
  }

  function renderBase(state, p, mine) {
    const band = el("div", "arbase " + (mine ? "mine" : "opp") + " " + U.pcls(p));
    band.setAttribute("data-anchor", "base-" + p);
    band.title = U.seatName(state, p) + "'s base";
    const loc = { t: "base", p: p };
    if (U.locIsCandidate(loc)) band.classList.add("highlight", "clickable-loc");
    if (U.isGroupDest(state, loc)) band.classList.add("clickable-loc", "dropok");
    band.onclick = function (ev) { U.clickLoc(loc, ev); };
    const units = el("div", "arbaseunits");
    const iids = Core.boardObjs(state, function (o, i2) {
      return !o.attachedTo && o.loc && o.loc.t === "base" && o.loc.p === p && !Core.isType(state, i2, "rune");
    });
    if (iids.length >= 7) units.classList.add("crowd2");
    else if (iids.length >= 5) units.classList.add("crowd1");
    for (const iid of iids) units.appendChild(U.renderPlate(state, iid));
    band.appendChild(units);
    return band;
  }

  function polar(cx, cy, r, deg) {
    const a = deg * Math.PI / 180;
    return { x: cx + r * Math.cos(a), y: cy + r * Math.sin(a) };
  }

  function arcPath(cx, cy, r, a0, a1) {
    const p0 = polar(cx, cy, r, a0);
    const p1 = polar(cx, cy, r, a1);
    const sweep = a1 > a0 ? 1 : 0;
    return "M " + p0.x.toFixed(2) + " " + p0.y.toFixed(2) +
      " A " + r + " " + r + " 0 0 " + sweep + " " + p1.x.toFixed(2) + " " + p1.y.toFixed(2);
  }

  const DIAL = { size: 160, r: 63, sw: 11, gap: 1.4 };

  function shownPoints(state, p) {
    return RB.Anim && RB.Anim.shownPoints ? RB.Anim.shownPoints(state, p) : state.players[p].points;
  }

  function dialArcs(points, total, top, on, off, p) {
    let out = "";
    const span = 180 / total;
    for (let i = 0; i < total; i++) {
      const lit = i < points;
      const a0 = top ? 180 + i * span + DIAL.gap : 180 - i * span - DIAL.gap;
      const a1 = top ? 180 + (i + 1) * span - DIAL.gap : 180 - (i + 1) * span + DIAL.gap;
      out += "<path d='" + arcPath(DIAL.size / 2, DIAL.size / 2, DIAL.r, a0, a1) + "' fill='none'" +
        " data-arc='" + p + "-" + i + "' data-on='" + on + "'" +
        " style='stroke:" + (lit ? on : off) + "' stroke-width='" + DIAL.sw + "'></path>";
    }
    return out;
  }

  const DIAL_COLOR = {
    cr: { on: "var(--crimson)", off: "#3a2620", txt: "var(--crimtxt)" },
    az: { on: "var(--azure)", off: "#22314a", txt: "var(--aztxt)" },
  };

  function scoreNode(state, p, cls) {
    const pl = state.players[p];
    const total = Core.victoryScore(state);
    const box = el("div", "arscore " + cls + " " + U.pcls(p));
    box.setAttribute("data-anchor", "crystal-" + p);
    const shown = shownPoints(state, p);
    if (shown >= total) box.classList.add("win");
    box.appendChild(el("span", null, String(shown)));
    const vNote = total !== state.mode.victory ? " (base " + state.mode.victory + ", modified by a battlefield)" : "";
    box.title = U.seatName(state, p) + " — " + pl.points + " / " + total + " points" + vNote;
    return box;
  }

  function renderDial(state) {
    const me = U.viewPlayer(state);
    const opp = Core.otherPlayer(me);
    const total = Math.max(1, Core.victoryScore(state));
    const wrap = el("div", "ardialbox");
    const dial = el("div", "ardial");
    dial.appendChild(el("div", "ardialface"));
    const topC = DIAL_COLOR[U.pcls(opp)];
    const botC = DIAL_COLOR[U.pcls(me)];
    const svg = "<svg viewBox='0 0 160 160' width='160' height='160'>" +
      dialArcs(shownPoints(state, opp), total, true, topC.on, topC.off, opp) +
      dialArcs(shownPoints(state, me), total, false, botC.on, botC.off, me) +
      "</svg>";
    const holder = el("div", "ardialsvg", svg);
    dial.appendChild(holder);
    dial.appendChild(scoreNode(state, opp, "top"));
    dial.appendChild(scoreNode(state, me, "bot"));
    const mid = el("div", "ardialmid");
    mid.appendChild(el("div", "arturn", "TURN " + state.turn.num));
    mid.appendChild(el("div", "zlabel arphase", esc(state.turn.phase.toUpperCase())));
    dial.appendChild(mid);
    wrap.appendChild(dial);
    let sub = U.seatName(state, state.turn.player) + "'s turn";
    if (state.showdown) sub = (state.showdown.combat ? "Combat" : "Showdown") + " at " + Core.name(state, state.showdown.bf);
    wrap.appendChild(el("div", "arturnsub " + U.pcls(state.turn.player), esc(sub)));
    const st = U.arenaStatus(state);
    wrap.appendChild(el("div", "arstatus " + st.cls, st.text));
    if (APP.error) wrap.appendChild(el("div", "arerr", "⚠ " + U.fmtText(APP.error)));
    return wrap;
  }

  function bfChips(state, bfIid) {
    return U.bfChips(state, bfIid, { cls: "arbfchips", name: U.seatName, holds: " HOLDS", unheld: "UNHELD", scored: "SCORED" });
  }

  function renderField(state, bfIid) {
    const me = U.viewPlayer(state);
    const opp = Core.otherPlayer(me);
    const bf = state.objs[bfIid];
    const c = Core.card(state, bfIid);
    const div = el("div", "arbf");
    div.setAttribute("data-anchor", "bf-" + bfIid);
    if (bf.controller !== null) {
      div.classList.add(U.pcls(bf.controller), bf.controller === me ? "ctlmine" : "ctlopp");
    }
    if (bf.contestedBy !== null) div.classList.add("contested");
    const hot = state.showdown && state.showdown.bf === bfIid;
    if (hot) div.classList.add(state.showdown.combat ? "combat" : "showdown");
    const loc = { t: "bf", iid: bfIid };
    if (U.locIsCandidate(loc)) div.classList.add("highlight", "clickable-loc");
    if (U.isGroupDest(state, loc)) div.classList.add("clickable-loc", "dropok");
    div.onclick = function (ev) { U.clickLoc(loc, ev); };

    const art = el("div", "arbfart");
    U.artStyle(art, state, bfIid, "full", 1400);
    div.appendChild(art);
    div.appendChild(el("div", "arbfveil"));
    div.appendChild(el("div", "arbfedge"));
    div.appendChild(el("div", "arbfline" + (hot ? " hot" : "")));
    div.appendChild(el("div", "arbfname", esc(c.name)));
    div.appendChild(bfChips(state, bfIid));
    div.appendChild(el("div", "arbftext", U.fmtText(U.stripReminder(c.text))));

    for (const side of [opp, me]) {
      const units = U.bfUnits(state, bfIid, side);
      const iids = units.iids;
      const row = el("div", "arbfrow " + (side === me ? "bot" : "top") + " " + U.pcls(side) + units.crowd +
        (iids.length ? "" : " empty"));
      row.title = U.seatName(state, side) + (iids.length ? "'s units here" : " has no units here");
      for (const iid of iids) row.appendChild(U.renderPlate(state, iid));
      div.appendChild(row);
    }
    for (const row of U.facedownRows(state, bfIid, me)) div.appendChild(row);
    return div;
  }

  function renderFields(state) {
    const area = el("div", "arfields");
    area.setAttribute("data-anchor", "table");
    area.onclick = function () { U.clickTable(); };
    const bfs = state.battlefields;
    const half = Math.ceil(bfs.length / 2);
    for (let i = 0; i < bfs.length; i++) {
      if (i === half) area.appendChild(renderDial(state));
      area.appendChild(renderField(state, bfs[i]));
    }
    if (half >= bfs.length) area.appendChild(renderDial(state));
    return area;
  }

  function fitStage() {
    const stage = document.getElementById("arstage");
    if (!stage || !stage.parentNode || !stage.parentNode.clientWidth) return;
    const host = stage.parentNode;
    const s = Math.min(host.clientWidth / W, host.clientHeight / H);
    if (!(s > 0)) return;
    stage.style.width = Math.max(W, Math.round(host.clientWidth / s)) + "px";
    stage.style.height = Math.max(H, Math.round(host.clientHeight / s)) + "px";
    const v = String(s);
    stage.style.setProperty("--s", v);
    const root = document.getElementById("arena");
    if (root) root.style.setProperty("--s", v);
  }

  let prioLast = null;
  let prioJumpAt = 0;
  const PRIO_JUMP_MS = 1200;

  function priorityGlow(state, me) {
    const pd = state.pending;
    if (state.over || !U.live() || !pd || pd.player === undefined || APP.prioGlow === "off") { prioLast = null; return null; }
    const local = !APP.ai[pd.player] && !(APP.net && pd.player !== APP.seat);
    const side = pd.player === me ? "bot" : "top";
    if (prioLast !== null && prioLast !== pd.player) prioJumpAt = Date.now();
    prioLast = pd.player;
    const elapsed = Date.now() - prioJumpAt;
    const jump = elapsed < PRIO_JUMP_MS;
    const cls = U.pcls(pd.player);
    const glow = el("div", "arprio v-" + APP.prioGlow + " " + side + " " + cls + (local ? "" : " wait") + (jump ? " arrive" : ""));
    const frag = document.createDocumentFragment();
    if (jump) {
      const band = el("div", "arpriojump to-" + side + " " + cls);
      band.style.animationDelay = "-" + elapsed + "ms";
      glow.style.setProperty("--jd", "-" + elapsed + "ms");
      frag.appendChild(band);
    }
    frag.appendChild(glow);
    return frag;
  }

  function renderArena(state) {
    const me = U.viewPlayer(state);
    const opp = Core.otherPlayer(me);
    if (typeof document !== "undefined" && document.body && document.body.classList) {
      document.body.classList.toggle("burnwarn", state.players[me].mainDeck.length <= 2 && !state.over);
    }
    const root = el("div", null);
    root.id = "arena";
    const fit = el("div", "arfit");
    const stage = el("div", "arstage");
    stage.id = "arstage";
    stage.appendChild(el("div", "arbg"));
    stage.appendChild(el("div", "argrain"));
    stage.appendChild(el("div", "arveil top " + U.pcls(opp)));
    stage.appendChild(el("div", "arveil bot " + U.pcls(me)));
    stage.appendChild(el("div", "arhorizon"));
    const prio = priorityGlow(state, me);
    if (prio) stage.appendChild(prio);
    stage.appendChild(renderCards(state, opp, false));
    stage.appendChild(renderRunes(state, opp, false));
    stage.appendChild(renderHand(state, opp, false));
    stage.appendChild(renderBase(state, opp, false));
    stage.appendChild(renderFields(state));
    stage.appendChild(renderBase(state, me, true));
    stage.appendChild(renderRunes(state, me, true));
    stage.appendChild(renderCards(state, me, true));
    stage.appendChild(renderHand(state, me, true));
    const overlay = U.modalMinimized(state) ? null : U.arenaOverlay(state);
    if (overlay) stage.appendChild(overlay);
    fit.appendChild(stage);
    root.appendChild(fit);
    watchHost(root);

    const held = RB.Anim && RB.Anim.heldItem ? RB.Anim.heldItem(state) : null;
    if (state.chain.length > (held ? 1 : 0)) {
      root.classList.add("haschain");
      root.appendChild(U.renderChain(state));
    }
    return root;
  }

  if (typeof window !== "undefined" && window.addEventListener) {
    window.addEventListener("resize", function () { fitStage(); });
  }
  let hostWatch = null;
  function watchHost(root) {
    if (typeof ResizeObserver === "undefined") return;
    if (!hostWatch) hostWatch = new ResizeObserver(function () { fitStage(); });
    hostWatch.disconnect();
    hostWatch.observe(root);
  }

  Object.assign(U, { renderArena: renderArena, fitArena: fitStage, ARENA_W: W, ARENA_H: H });
})();
